
import { IModal } from "@/services/modal-service";
import Vue from "vue";

export default Vue.extend({
	props: {
		modal: {
			type: Object as ()=>IModal,
			required: true
		}
	},
	computed: {
		plain():boolean {
			return !!(this.modal.options && this.modal.options.plain);
		},
		subtitle():string {
			return (this.modal.options && this.modal.options.subtitle) || "";
		},
		classes():string[]{
			let result:string[] =[];
			if (!this.modal.options) return result;
			if (this.modal.options.padded){
				result.push("padded");
			}
			return result;
		},
		style():any{
			let result:any = {};
			if (this.modal.width){
				result.width = "100%";
				result.maxWidth = `${this.modal.width}px`;
			}
			if (this.modal.height){
				result.height = "100%";
				result.maxHeight = `${this.modal.height}px`;
				result.alignSelf = "center";
			}

			return result;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		}
	}
});
